import { useForm, Link } from '@inertiajs/react'
import { ArrowRight, Loader2, Mail } from 'lucide-react'
import { AuthLayout } from '@/components/layout/AuthLayout'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

type NewProps = {
  email?: string
}

export default function RegistrationsNew({ email }: NewProps) {
  const { data, setData, post, processing, errors } = useForm({
    email_address: email || ''
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/registration')
  }

  return (
    <AuthLayout
      title="Sign Up"
      heading="Get started with Corppy"
      description="Create an account to form your business. It only takes a few minutes."
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-1.5">
          <Label htmlFor="email_address" className="text-[13px] font-medium text-foreground/70">
            Work email
          </Label>
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground/40" />
            <Input
              id="email_address"
              type="email"
              placeholder="name@company.com"
              value={data.email_address}
              onChange={e => setData('email_address', e.target.value)}
              autoComplete="email"
              autoFocus
              required
              className="h-11 pl-10"
            />
          </div>
          {errors.email_address && (
            <p className="text-sm text-destructive">{errors.email_address}</p>
          )}
        </div>

        <Button type="submit" className="w-full h-11 text-sm font-semibold gap-2" disabled={processing}>
          {processing ? (
            <>
              <Loader2 className="animate-spin h-4 w-4" />
              Sending code...
            </>
          ) : (
            <>
              Create account
              <ArrowRight className="w-4 h-4" />
            </>
          )}
        </Button>
      </form>

      <p className="mt-4 text-center text-[11px] text-muted-foreground/60 leading-relaxed">
        By creating an account you agree to our Terms of Service and Privacy Policy.
      </p>

      <div className="mt-8 pt-6 border-t border-border/60 text-center">
        <p className="text-[13px] text-muted-foreground">
          Already have an account?{' '}
          <Link href="/session/new" className="text-primary font-semibold hover:underline underline-offset-2">
            Sign in
          </Link>
        </p>
      </div>
    </AuthLayout>
  )
}
